export default "__VITE_ASSET__CWgt1mIv__"